module.exports = __webpack_public_path__ + "img/microphone.9d2f105a.svg";